import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CardContainer, CardBody, CardItem } from './Product3dCard.tsx';
import { useLanguage } from '../../store/languageContext.jsx';
import translate from '../../utils/translation.js';
const ProductCard = ({ product }) => {
    const navigate = useNavigate();
    const parsedImages = Array.isArray(product.images) ? product.images : JSON.parse(product.images || '[]');
    const { language } = useLanguage();
    const handleClick = (e) => {
        e.preventDefault();
        navigate(`/product/${product.id}`);
    };

    return (
        <CardContainer className="inter-var" onClick={handleClick}>
            <CardBody className="bg-[#242424] relative group/card dark:hover:shadow-2xl dark:hover:shadow-emerald-500/[0.1] border-white/[0.2] w-auto h-auto rounded-xl p-4 sm:p-5 md:p-6 border flex flex-col">
                <CardItem
                    translateZ="50"
                    className="text-lg sm:text-xl font-bold text-neutral-600 dark:text-white line-clamp-1"
                >
                    {product.title}
                </CardItem>
                <CardItem
                    as="p"
                    translateZ="60"
                    className="text-neutral-500 text-xs sm:text-sm max-w-sm mt-1.5 sm:mt-2 dark:text-neutral-300"
                >
                    {product.category} - {product.brand_name}
                    <div>
                        {product.price} {translate[language].egp}
                    </div>
                </CardItem>
                <CardItem
                    as="p"
                    translateZ="70"
                    className="text-neutral-500 text-[11px] sm:text-xs max-w-sm mt-1 dark:text-neutral-300 opacity-50"
                >
                    {translate[language].LastUpdated}: {new Date(product.update_date).toLocaleDateString()}
                </CardItem>
                <CardItem translateZ="100" className="w-full mt-3 sm:mt-4">
                    <img
                        src={parsedImages[0] || '/placeholder.jpg'}
                        alt={product.title}
                        className="w-full h-[160px] sm:h-[180px] md:h-[200px] object-cover rounded-xl group-hover/card:shadow-xl"
                    />
                    <CardItem translateZ="50" className="w-full shadow-lg">
                        <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 bg-black/50 border overflow-hidden rounded-full size-8 sm:size-10 min-w-8 sm:min-w-10">
                            <img src={product.brand_image} alt="" className='w-full' />
                        </div>
                    </CardItem>
                </CardItem>
                <div className="flex justify-between items-end flex-1 mt-3 sm:mt-4 gap-2">
                    <CardItem
                        translateZ={20}
                        as="button"
                        className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl text-[11px] sm:text-xs font-normal dark:text-white opacity-50 cursor-default"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {translate[language].details} →
                    </CardItem>
                    <CardItem
                        translateZ={20}
                        as="button"
                        className="px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl bg-black dark:bg-white dark:text-black text-white text-[11px] sm:text-xs font-bold"
                        onClick={handleClick}
                    >
                        {translate[language].viewProduct}
                    </CardItem>
                </div>
            </CardBody>
        </CardContainer>
    );
};

export { ProductCard };